import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const PaymentFail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [paymentRedirection, setPaymentRedirection] = useState(null);
  useEffect(() => {
    const payment_redirection = localStorage.getItem('payment_redirection');
    if (payment_redirection) {
      const payment_redirection_data = JSON.parse(payment_redirection);
      setPaymentRedirection(payment_redirection_data);
      //   navigate(`/${payment_redirection_data.type}/${payment_redirection_data.course_id || payment_redirection_data.mock_id}`);
    }
  }, []);

  function isWebViewCheck() {
    const userAgent = navigator.userAgent.toLowerCase();

    // Check for common webview keywords
    const webviewKeywords = [
      'webview',
      'wkwebview',
      'crosswalk',
      'xwalk',
      'cordova',
      'ionic',
      'phonegap',
      'tachyonic',
      'meteor',
      'electron',
    ];

    for (let i = 0; i < webviewKeywords.length; i++) {
      if (userAgent.indexOf(webviewKeywords[i]) !== -1) {
        return true;
      }
    }

    return false;
  }
  const iswebView = isWebViewCheck();
  console.log('device', iswebView);
  console.log('Params from payment', params);

  if (iswebView) {
    return null;
  }

  return (
    <div className='d-flex flex-column align-items-center justify-content-center '>
      <div className='payment-success-container'>
        <div className='position-relative'>
          <img src={'/img/payment_success_box.png'} alt='success' className='payment-success-box' />
          <img
            src={'/img/payment_success_robot.png'}
            alt='success'
            className='payment-success-robot'
          />
        </div>
        <h1>Payment Failed!</h1>
        <p className='payment_desc'>
          Oops! This should not have happened. No problem, would you like to try again?
        </p>
        <div className='d-flex flex-column gap-2'>
          <button
            className='continue-button'
            onClick={() => {
              navigate(-1);
            }}
          >
            Try Payment Again
          </button>
          {console.log('paymentRedirection', paymentRedirection)}
          <button
            className='continue-button go-back-button'
            onClick={() => {
              if (paymentRedirection) {
                if (paymentRedirection.type == 'Course') {
                  navigate(`/course/${paymentRedirection.course_id}`);
                } else {
                  navigate(`/`);
                }
              }
            }}
          >
            No, go back to Courses
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;
